@layer chart {
  .menuBarRoot {
    display: flex;
  }

  .menuItem {
    height: 40px;
    padding: 0 4px;
    border-right: 1px solid var(--border-soft);
    display: flex;
    align-items: center;
  }

  .menuItemSearch {
    min-width: 132px;

    button {
      justify-content: left;
    }
  }

  .menuBarRoot .menuItem [data-button] {
    &:disabled {
      border: none;
    }
  }
}
